import ChallanBaseInput from "./ChallanBaseInput";
import { MenuItem } from "../helper";

export default function ChallanSelectInput({ options, ...rest }) {
  return (
    <ChallanBaseInput select {...rest}>
      {options.map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </ChallanBaseInput>
  );
}
